var lookup = {
  exports: {}
};

export { lookup as l };
//# sourceMappingURL=lookup.js.map
